import React from 'react';
import { TextField, OutlinedInput, InputLabel, FormControl, styled } from '@mui/material';

// Custom premium styling for all form text fields
const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 12,
    background: 'var(--bg-elevated)',
    transition: 'all 0.2s ease',
    '& fieldset': {
      borderColor: 'var(--border-subtle)',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(45,132,255,0.5)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'var(--accent-blue)',
      borderWidth: 2,
    },
    '&.Mui-focused': {
      background: 'rgba(45,132,255,0.05)',
      boxShadow: '0 0 0 4px rgba(45,132,255,0.1)',
    },
  },
  '& .MuiInputLabel-root': {
    color: 'var(--text-muted)',
    fontFamily: 'Inter, sans-serif',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: 'var(--accent-blue)',
  },
  '& .MuiOutlinedInput-input': {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    color: 'var(--text-primary)',
    padding: '14px 16px',
  },
}));

export const PremiumTextField = (props) => (
  <StyledTextField variant="outlined" margin="normal" fullWidth {...props} />
);

// Specifically for fields with Adornments (like % or ₹) where OutlinedInput is used directly
export const PremiumOutlinedInput = styled(OutlinedInput)(({ theme }) => ({
  borderRadius: 12,
  background: 'var(--bg-elevated)',
  fontFamily: 'Inter, sans-serif',
  fontWeight: 600,
  color: 'var(--text-primary)',
  transition: 'all 0.2s ease',
  '& fieldset': {
    borderColor: 'var(--border-subtle)',
  },
  '&:hover fieldset': {
    borderColor: 'rgba(45,132,255,0.5)',
  },
  '&.Mui-focused fieldset': {
    borderColor: 'var(--accent-blue)',
    borderWidth: 2,
  },
  '&.Mui-focused': {
    background: 'rgba(45,132,255,0.05)',
    boxShadow: '0 0 0 4px rgba(45,132,255,0.1)',
  },
}));

export const PremiumFormControl = styled(FormControl)(({ theme }) => ({
  width: '100%',
  marginTop: 16,
  marginBottom: 8,
  '& .MuiInputLabel-root': {
    color: 'var(--text-muted)',
    fontFamily: 'Inter, sans-serif',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: 'var(--accent-blue)',
  },
}));
